<template>
	<div
		class="order-switch"
		:title="roomsOrdersStore.reservationsViewMode === 'timeline' ? getString('list_view') : getString('timeline_view')"
		v-html="svgStore.get(roomsOrdersStore.reservationsViewMode === 'timeline' ? 'iconListView' : 'iconTimeView')"
		@click="toggleViewMode"></div>
</template>

<script>
import {useRoomsOrdersStore} from "@/console-new/stores";
import {useLanguageStore, useSvgStore} from "@/shared/stores";

export default {
	name: "ReservationsViewToggle",
	setup() {
		const languageStore = useLanguageStore();
		const roomsOrdersStore = useRoomsOrdersStore();
		const svgStore = useSvgStore();
		return {
			getString: languageStore.getString,
			roomsOrdersStore,
			svgStore
		};
	},
	methods: {
		toggleViewMode() {
			this.roomsOrdersStore.setReservationsViewMode(this.roomsOrdersStore.reservationsViewMode === 'timeline' ? 'list' : 'timeline');
		},
	},
};
</script>

<style scoped lang="scss">
.order-switch {
	border-radius: 13px;
	border: 1px solid var(--color-primary);
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 9px;
	cursor: pointer;
	flex-shrink: 0;
	transition: background-color 0.3s ease;
	width: 40px;
	height: 40px;

	:deep(svg) {
		width: 20px;
		height: 20px;

		.fill {
			fill: var(--color-primary);
		}

		.stroke {
			stroke: var(--color-primary);
		}
	}
}
</style>
